import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import * as SwiperNew from "../../js/swipe-4";

export default class PaymentMethodBT {
    splide;

    slideClass = 'jet-listing-grid__item';

    wrapperClass = 'jet-listing-grid__items';

    swiperOptions = {
        slidesPerView: 2,
        slidesPerGroup: 2,
        slidesPerColumn: 2,
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };

    constructor() {
        this.addEvents();
    }

    addEvents() {
        const splideElements = document.querySelectorAll('.partner-carousel .jet-listing-grid');
        const splideGeneral = document.querySelector('.partner-carousel');

        if (!splideElements) return;

        const that = this;
        if(jQuery('div').hasClass('partner-carousel') && document.body.offsetWidth <= 768){
            setTimeout(() => {
                splideElements.forEach((splideElement) => {
                    // init swiper
                    splideElement.classList.add('swiper-container');
                    let swiperSlides = splideElement.querySelectorAll(`.${this.slideClass}`);
                    if (document.body.offsetWidth <= 768 && swiperSlides.length > 2) {
                        splideElement.innerHTML += (`<div class="swiper-pagination"></div>`);
                    } else {
                        splideElement.classList.add('not-swipper');
                    }
                    const swiperWrapper = splideElement.querySelector(`.${this.wrapperClass}`);
                    swiperWrapper.setAttribute('class', 'swiper-wrapper');
                    swiperSlides = splideElement.querySelectorAll(`.${this.slideClass}`);
                    swiperSlides.forEach((el) => {
                        el.setAttribute('class', 'swiper-slide');
                    });
                    if (document.body.offsetWidth <= 768 && swiperSlides.length > 2) {
                        new SwiperNew(splideElement, that.swiperOptions);
                    }
                });
            }, 500)
        }else {
            splideElements.forEach((splideElement) => {
                // init splide
                document.querySelector('.partner-carousel>div').classList.add('splide');
                splideElement.classList.add('splide__track');
                const splideWrapper = splideElement.querySelector(`.${this.wrapperClass}`);
                splideWrapper.setAttribute('class', 'splide__list');

                const splideSlides = splideElement.querySelectorAll(`.${this.slideClass}`);
                splideSlides.forEach((el) => {
                    el.setAttribute('class', 'splide__slide');
                });
                if (splideSlides.length > 4) {
                    new Splide('.partner-carousel>.elementor-widget-container', {
                        type: 'loop',
                        autoWidth: true,
                        perPage: 3,
                        interval: 1,
                        gap: '70px',
                        drag: 'free',
                        focus: 'left',
                        autoScroll: {
                            speed: 1,
                        },
                        breakpoints: {
                            640: {
                                perPage: 4,
                                speed: 15000,
                                gap: '5px',
                                pagination: true,
                            },
                        }
                    }).mount({AutoScroll});
                }

            });
        }
        window.addEventListener('load', e => {
            if(splideGeneral) {
                splideGeneral.classList.add('loaded');
            }
        });
    }
}
